import { FieldInputProps, useField, useFormikContext } from "formik";
import React from "react";

import { FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { TextField } from "../TextField";
import { useSetFieldTouched } from "../useSetFieldTouched";

type NumericInputFieldProps = Readonly<{
  name: string;
  minValue?: number;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const NumericInputField = (props: NumericInputFieldProps) => {
  const { minValue, disabled, isSaving, isRequiredField } = props;

  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  useSetFieldTouched(field.name);

  const onNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    if (!minValue) {
      return field.onChange;
    }

    const targetValue = Number(e.target.value);
    setFieldValue(field.name, targetValue < minValue ? null : targetValue);
    return field.onChange;
  };

  return (
    <TextField
      {...props}
      isRequiredField={isRequiredField}
      disabled={disabled}
      isSaving={isSaving}
      customOnChange={minValue ? onNumberChange : undefined}
      type="number"
    />
  );
};
